import { render } from "./EmployerPage.vue?vue&type=template&id=20dd7615&scoped=true"
import script from "./EmployerPage.vue?vue&type=script&lang=js"
export * from "./EmployerPage.vue?vue&type=script&lang=js"

import "./EmployerPage.vue?vue&type=style&index=0&id=20dd7615&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20dd7615"]])

export default __exports__